import { useTexts } from './useTexts'
import { mixOptionId, useOptions } from './useOptions'
import { SimpleSelect } from '@workwave-tidal/core/components'
import { useOnChange } from './useOnChange'

type MixedProps = {
  onChangeField: (value: uui.domain.ui.forms.RecurrenceSettings) => void
}

export function MixedDropdown(props: MixedProps) {
  const { onChangeField } = props
  const texts = useTexts()
  const options = useOptions()
  const onChange = useOnChange(onChangeField)

  return (
    <SimpleSelect
      value={mixOptionId}
      options={options}
      onChange={onChange}
      label={texts.recurrence}
    />
  )
}
